exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-wallet-list-panel{width:calc(100% - 350px);height:calc(100vh - 104px);left:350px;top:104px;position:absolute;background-color:#fff;-webkit-box-shadow:0 2px 10px 0 rgba(0,0,0,.05);box-shadow:0 2px 10px 0 rgba(0,0,0,.05);overflow:auto}", ""]);

// exports
